
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pietra-partners",
      function () {
        return require("private-next-pages/pietra-partners/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pietra-partners"])
      });
    }
  